// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1T22Q","buttons":"PendingPaymentAlert_buttons__3bvHu"};